import { AdDrilldown } from "src/pages/ad-studio/insights/ad-drilldown";
import { EntityDrilldown } from "src/pages/ad-studio/insights/entity-drilldown";
import { EntityDrilldownPrimitive } from "src/pages/ad-studio/insights/entity-drilldown-primitive";
import type {
  DrillScopeArgs,
  ParentGrain,
} from "src/pages/ad-studio/insights/performance/types";
import type { DrillEmbedAttrs } from "src/pages/ad-studio/insights/performance/utils/embeds";
import { useDrillScope } from "src/pages/ad-studio/insights/performance/use-drill-scope";

const AdDrilldownEmbed = ({
  id,
  scope,
}: {
  id: string;
  scope: DrillScopeArgs;
}) => {
  const drill = useDrillScope(scope);
  return <AdDrilldown drill={drill} id={id} listed="no-list-row" />;
};

const EntityDrilldownEmbed = ({
  grain,
  id,
  scope,
}: {
  grain: ParentGrain;
  id: string;
  scope: DrillScopeArgs;
}) => {
  const drill = useDrillScope(scope);
  return (
    <EntityDrilldown drill={drill} grain={grain} id={id}>
      <EntityDrilldownPrimitive.Header />
      <EntityDrilldownPrimitive.Children />
    </EntityDrilldown>
  );
};

type DrilldownEmbedProps = { attrs: DrillEmbedAttrs };

export const DrilldownEmbed = ({ attrs }: DrilldownEmbedProps) => {
  switch (attrs.grain) {
    case "ad": {
      return <AdDrilldownEmbed id={attrs.id} scope={attrs.scope} />;
    }
    case "ad_set":
    case "campaign": {
      return (
        <EntityDrilldownEmbed
          grain={attrs.grain}
          id={attrs.id}
          scope={attrs.scope}
        />
      );
    }
    default: {
      return attrs.grain satisfies never;
    }
  }
};
